import React, { useState } from 'react'
import SpanishLogo from '../../../../../Components/Header/Assets/Img/SpanishLogo.png'
import EnglishLogo from '../../../../../Components/Header/Assets/Img/EnglishLogo.png'
import { ArrowDown2, ShoppingCart, Location } from 'iconsax-react'
import ProcedureSearch from '../../../../../Components/ProcedureSearch/ProcedureSearch'
import "./assets/style.css"

const Find = () => {


    const ubicationData = [
        { id: 1, location: 'Colombia' },
        { id: 2, location: 'España' },
        { id: 3, location: 'United States' },
        { id: 4, location: 'Canada' },
        { id: 5, location: 'Panamá' },
    ]

    // const languageData = [
    //     { id: 1, language: 'Español', logo: SpanishLogo },
    //     { id: 2, language: 'Inglés', logo: EnglishLogo },
    //     { id: 3, language: 'Francés', logo: EnglishLogo }
    // ]

    const [loading, setLoading] = useState(false)
    const [dataSelect, setDataSelect] = useState([])
    const [resultadoShow, setResultadoShow] = useState(false)
    const [textBusqueda, setTextBusqueda] = useState("")
    const [locationDroped, setLocationDroped] = useState(false)
    const [locationSelected, setLocationSelected] = useState('Ubicación')

    const [languageDroped, setLanguageDroped] = useState(false)
    const [languageSelected, setLanguageSelected] = useState('Español')
    const [languageLogoSelected, setLanguageLogoSelected] = useState(SpanishLogo)

    const locationDropedFunction = (e) => {
        const clicked = e.target.attributes.category.value
        setLocationSelected(clicked)
        setLocationDroped(false)
    }
    const languageDropedFunction = (e) => {
        const clicked = e.target.attributes.category.value
        setLanguageSelected(clicked)
        setLanguageDroped(false)
        clicked === 'Español' ? setLanguageLogoSelected(SpanishLogo) : clicked === 'Inglés' ? setLanguageLogoSelected(EnglishLogo) : setLanguageLogoSelected(EnglishLogo)
    }



    return (
        <section className='form-find-b'>
{/*           
                <div className='headerSearch'>
                    <div className='headerSearch_location' onClick={() => setLocationDroped(!locationDroped)}>
                        <div className='headerSearch_location_'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Location size="32" color="#004274" />
                                <p className='headerSearch_text'>{locationSelected}</p>
                            </div>
                            <ArrowDown2 size="32" color="#004274" />
                        </div>
                        {locationDroped &&
                            <div className='headerSearch_locationDroped'>
                                <div style={{ width: '90%', height: '90%' }}>
                                    {ubicationData.map((data) => {
                                        return (
                                            <button className='headerSearch_locationDropedButton' category={data.location} onClick={locationDropedFunction}>{data.location}</button>
                                        )
                                    })}
                                </div>
                            </div>
                        }
                    </div>
                    <div className='procedureSearch_search'>
                        <ProcedureSearch setDataSelect={setDataSelect} setLoading={setLoading} setResultadoShow={setResultadoShow} setTextBusqueda={setTextBusqueda} />
                    </div>
                    <div className='headerSearch_language'>
                        <div className='headerSearch_language_' >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div >
                                    <ShoppingCart size={30} color='#004274'></ShoppingCart>
                                </div>
                                <p className='headerSearch_text'>Mi Carrito</p>
                            </div>
                        </div>
                        
                    </div>
                </div> */}
            
        </section>
    )
}

export default Find